import 'css-chunksrc/client/scenes/wbs/quickElementLoader/styles.scss';export default {
  "quickElementLoader": "_quickElementLoader_u2nr2_1"
};